<template>
  <div>
    <el-dialog
      v-if="videoVisible"
      fullscreen
      :visible.sync="videoVisible"
      @close="onClose"
    >
      <video-player
        ref="vdo"
        :order="loadedOrder"
        :startVideo="startVideoTime"
        :segmentsData="segments"
        :eventsData="eventsData"
        :timeMarksData="timeMarks"
        @close="onClose"
      ></video-player>
    </el-dialog>
  </div>
</template>

<script>
import orderApi from "@/services/orders.api";
import VideoPlayer from "./VideoPlayer";
export default {
  name: "VideoPlayerView",
  components: {
    "video-player": VideoPlayer,
  },
  props: ["order", "startVideo"],
  data() {
    return {
      loadedOrder: {},
      startVideoTime: 0,
      videoVisible: false,
      segments: null,
      eventsData: null,
      timeMarks: null,
    };
  },
  async created() {
    if (!this.order) {
      const id = this.$route.params.id;
      try {
        const response = await orderApi.fetchById(id);
        this.loadedOrder = response.data;
        if (
          this.loadedOrder.status === 5 &&
          this.loadedOrder.groupId === this.loadedOrder.id
        ) {
          const segmentsData = await orderApi.fetchOrderSegments(id);
          this.segments = segmentsData.segments;
          this.eventsData = segmentsData.events;
          this.timeMarks = segmentsData.timeMarks;
        }
        this.videoVisible = true;
      } catch (err) {
        console.log(err);
      }
    } else {
      this.loadedOrder = this.order;
      if (
        this.loadedOrder.status === 5 &&
        this.loadedOrder.groupId === this.loadedOrder.id
      ) {
        try {
          const segmentsData = await orderApi.fetchOrderSegments(
            this.loadedOrder.id
          );
          this.segments = segmentsData.segments;
          this.eventsData = segmentsData.events;
          this.timeMarks = segmentsData.timeMarks;
        } catch (err) {
          console.error("Error cargando segmentos:", err);
        }
      }
      this.videoVisible = true;
    }
    if (!this.startVideo) {
      this.startVideoTime = 0;
    } else {
      this.startVideoTime = this.startVideo;
    }
  },
  methods: {
    onClose() {
      if (this.order) {
        this.$router.go(-1);
      } else {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style>
/* El diálogo ocupa toda la pantalla sin padding ni cabecera visible */
.el-dialog.is-fullscreen {
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
  max-width: 100vw;
  box-sizing: border-box;
}

.el-dialog__header {
  padding: 0 !important;
  flex-shrink: 0;
}

.el-dialog__body {
  padding: 0 !important;
  flex: 1;
  overflow: hidden !important;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  box-sizing: border-box;
}

/* Ocultamos el botón de cierre nativo del diálogo —
   el cierre lo gestiona el botón de la topbar de VideoPlayer */
.el-dialog__headerbtn {
  display: none !important;
}
</style>
